module.exports = __webpack_public_path__ + "img/GetBoarded_Logo.55baeb6b.svg";